import { IChangedBusyTimeDatasource } from '../datastore/time/changed_busy_time_datasource';
import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';

function saveChangedBusyTimeCommand(
  defineCommand: any,
  ngChangedBusyTimeDatasource: IChangedBusyTimeDatasource,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  defineCommandORM: IDefineCommand
) {
  return defineCommandORM('saveChangedBusyTimeCommand', function saveChangedBusyTimeCommand(deferred: any, time: any) {
    const changedBusyTime = _4.find(ngChangedBusyTimeDatasource.read(), { tracking_id: time.tracking_id });
    const originalTime = _4.find(ngTimeOccurrenceDataSource.read(), { trackingId: time.tracking_id });

    if (originalTime) {
      _4.merge(originalTime, time);
    }

    if (changedBusyTime) {
      _4.merge(changedBusyTime, time);
    } else {
      ngChangedBusyTimeDatasource.write([time]);
    }
    deferred.resolve(ngChangedBusyTimeDatasource);
  });
}

angular.module('ui-ng-calendar').factory('saveChangedBusyTimeCommand', saveChangedBusyTimeCommand);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/save_changed_busy_time.ts